import { CSSProperties } from 'react'

export type EnumLiteralsOf<T extends object> = T[keyof T]

/**
 * Returns object T, but with T[K] overridden to type U.
 * @example
 * type MyObject = { a: number, b: string }
 * OverrideProperty<MyObject, "a", string> // returns { a: string, b: string }
 */
export type OverrideProperty<T, K extends keyof T, U> =
  Omit<T, K> & { [P in keyof Pick<T, K>]: U }

export enum SortDirection {
  DESC = 'desc',
  ASC = 'asc'
}

export type Overwrite<T, U> = Pick<T, Exclude<keyof T, keyof U>> & U

export type StyleProps = {
  className?: string
  style?: CSSProperties
}

export type PaginationProps<SortPropType> = {
  page: number
  size: number
  sortProp: SortPropType
  sortDirection: SortDirection,
  totalElements: number
  totalPages: number
}

export type FilterRange = {
  min: number
  max: number
}

export enum Sex {
  MALE = 'MALE',
  FEMALE = 'FEMALE'
}

export enum FileStatus {
  PROCESSING,
  LOADING,
  LOADED,
  UPLOADING,
  UPLOADED,
  ERROR
}

export type FormConstraints<F = any> = {
  [key in keyof F]?: any
}
